import { AddSharp } from "@mui/icons-material";
import { Avatar, AvatarGroup, Box, Button } from "@mui/material";
import { useState } from "react";
import { StyledModal } from "../../common";
import AddStudyEditors from "../AddStudy/AddEditorsModal";
import { User } from "../models";
import useStudyEditorsStore from "./useStudyEditorsStore";

interface Props {
  editors: string[]; // list of editor as USIX ID's
  onSaveEditors: (editors: User[]) => void;
}

export default function ManageEditorsControl({ editors, onSaveEditors }: Props) {
  const [modalOpen, setModalOpen] = useState(false);
  const { getInitials } = useStudyEditorsStore();

  const handleOnSaveEditors = (editors: User[]) => {
    onSaveEditors(editors);
    setModalOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mt: "1rem",
        flex: 1,
      }}
    >
      <AvatarGroup max={5}>
        {editors.map((editor, index) => (
          <Avatar alt={editor} sx={{ bgcolor: "#003087" }} key={index}>
            {getInitials(editor)}
          </Avatar>
        ))}
      </AvatarGroup>
      <Button
        onClick={() => {
          setModalOpen(true);
        }}
        variant="text"
        color="primary"
        size="medium"
        startIcon={<AddSharp sx={{ color: "#003087" }} />}
        sx={{ color: "#003087", fontSize: "15px" }}
      >
        MANAGE EDITORS
      </Button>

      <StyledModal
        children={<AddStudyEditors editors={editors ?? []} onSaveEditors={handleOnSaveEditors} />}
        open={modalOpen}
        handleModalClose={() => {
          setModalOpen(false);
        }}
        title="Add Study Editors"
      />
    </Box>
  );
}
